import React from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { getUserDetails } from '../../../services/user';
import { useParams, useHistory } from 'react-router-dom';
import DetailsPage from '../../../shared/components/DetailsPage/DetailsPage';
import OrgPortfoliosTable from './Tabs/OrgPortfoliosTable';
import OrgsTable from './Tabs/OrgsTable';

const UserDetails = () => {
  const { t: translate } = useTranslation();
  const { FundID } = useParams();
  const history = useHistory();

  const [userData, setUserData] = useState(history?.location?.state?.userData || {});
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const [orgsCount, setOrgsCount] = useState(null);
  const [orgPortfoliosCount, setOrgPortfoliosCount] = useState(null);

  useEffect( () => {
    const getDetails = async () => {
      try {
        setLoading(true);
        const response = await getUserDetails(FundID);
        setUserData(response.data);
      } catch (err) {
        setMessage(translate('it was not possible to search user details'));
      }
      setLoading(false);
    };

    if (!Object.keys(userData).length) {
      getDetails();
    }
  }, [FundID, userData, translate]);


  const header = {
    title: userData?.name,
    fields: [
      {
        name: 'userId',
        data: userData?.id
      },
      {
        name: 'email',
        data: userData?.email
      },
      {
        name: 'status',
        data: translate(userData?.status)
      }
    ]
  };

  const tabs = [
    {
      name: `${translate('organizations')}` + (orgsCount !== null ? ` (${orgsCount})` : ''),
      content: {
        component: OrgsTable,
        props: {
          setOrgsCount
        }
      }
    },
    {
      name: `${translate('organizations portfolios')}` + (orgPortfoliosCount !== null ? ` (${orgPortfoliosCount})` : ''),
      content: {
        component: OrgPortfoliosTable,
        props: {
          setOrgPortfoliosCount
        }
      }
    }
  ];

  return (
    <DetailsPage
      tabs={tabs}
      message={message}
      loading={loading}
      header={header}
      data={userData}
      setMessage={setMessage}
    />
  );
};

export default UserDetails;
